import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "c-sidebar-brand" }
const _hoisted_2 = { class: "c-sidebar-top" }
const _hoisted_3 = {
  key: 0,
  class: "top-router"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "center-top-sidebar" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "DSI E-commerce"),
  /*#__PURE__*/_createElementVNode("span", { class: "desc" }, "A Click at all Time!")
], -1)
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = ["title"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "col-12 txt-center"
}
const _hoisted_14 = { style: {"font-size":"var(--sidebar-font-size)","color":"var(--black-light)"} }
const _hoisted_15 = ["onClick", "title"]
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { key: 0 }

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_c_input = _resolveComponent("c-input")
  const _component_c_modal = _resolveComponent("c-modal")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.$helper?.getSidebars?.value?.width, "c-sidebar"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.$helper?.getSidebars?.value?.width === 'fix-sidebar')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: require('@/assets/icons/sidebars/login-page.svg'),
                    class: "logo"
                  }, null, 8, _hoisted_4),
                  _hoisted_5
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.toggleSidebar(_ctx.$helper?.getSidebars?.value?.width)), ["stop"])),
          class: "right-top-sidebar",
          style: _normalizeStyle(_ctx.$helper?.getSidebars?.value?.width !== 'fix-sidebar' && 'margin-left: 4px;'),
          title: "Collapse"
        }, [
          (_ctx.$helper?.getSidebars?.value?.width === 'fix-sidebar')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: require('@/assets/icons/sidebars/menu-exstand.svg'),
                class: "collapsed"
              }, null, 8, _hoisted_6))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: require('@/assets/icons/sidebars/menu-exstand-right.svg'),
                class: "collapsed"
              }, null, 8, _hoisted_7))
        ], 4)
      ]),
      _createElementVNode("div", {
        style: _normalizeStyle({
        padding: _ctx.$helper?.getSidebars?.value?.width === 'fix-sidebar' ? 'var(--sidebar-padding)' : '10px!important'
      }),
        class: "bottom-top-sidebar"
      }, [
        (_ctx.$helper?.getSidebars?.value?.width !== 'fix-sidebar')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.toggleSidebarActive && _ctx.toggleSidebarActive(...args))),
                class: "bg-search"
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/icons/sidebars/search.svg'),
                  alt: ""
                }, null, 8, _hoisted_9)
              ])
            ]))
          : (_openBlock(), _createBlock(_component_c_input, {
              key: 1,
              value: _ctx.keySearch,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => ((_ctx.keySearch) = $event)),
              schema: _ctx.onSearch,
              placeholder: "componentSearch",
              className: "p10",
              searchable: ""
            }, null, 8, ["value", "schema"]))
      ], 4)
    ]),
    _createElementVNode("div", {
      class: "c-sidebar-content",
      style: _normalizeStyle({
    padding: _ctx.$helper?.getSidebars?.value?.width === 'fix-sidebar' ? 'var(--sidebar-padding)' : '10px!important'
  })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (sidebar, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          title: _ctx.$helper?.getSidebars?.value?.width !== 'fix-sidebar' ? (_ctx.$i18n.locale === 'en' ? sidebar?.title : sidebar?.titleForeign) : '',
          class: _normalizeClass([_ctx.$helper?.getSidebars?.value?.width !== 'fix-sidebar' ? 'min-link-item':'', "link-item"])
        }, [
          _createVNode(_component_router_link, {
            onClick: _ctx.onSidebarClick,
            to: `${sidebar?.adminRouteUrl || '/'}`,
            class: _normalizeClass((_ctx.getActive(sidebar?.adminRouteUrl, _ctx.$route, sidebar) || (_ctx.$route?.path === '/dashboard' && (sidebar?.title === 'dashboard' || sidebar?.title === 'Dashboard'))) && 'c-link-active')
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: sidebar?.icon ? _ctx.$helper?.getFullImage(sidebar?.icon) : require('./undifined.svg'),
                alt: '',
                style: {"margin-top":"-1px"}
              }, null, 8, _hoisted_11),
              (_ctx.$helper?.getSidebars?.value?.width === 'fix-sidebar')
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$i18n.locale === 'en' ? sidebar?.title : sidebar?.titleForeign), 1))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["onClick", "to", "class"])
        ], 10, _hoisted_10))
      }), 128)),
      (!_ctx.menus.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("errorEmpty")), 1)
          ]))
        : _createCommentVNode("", true)
    ], 4),
    _createElementVNode("div", {
      style: _normalizeStyle({
      padding: _ctx.$helper?.getSidebars?.value?.width === 'fix-sidebar' ? 'var(--sidebar-padding)' : '10px!important'
    }),
      class: "c-sidebar-footer"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerSidebars, (footer, index) => {
        return (_openBlock(), _createElementBlock("div", {
          onClick: _withModifiers($event => (_ctx.isLogoutFunc(footer)), ["stop"]),
          key: index,
          title: _ctx.$helper?.getSidebars?.value?.width !== 'fix-sidebar' ? _ctx.$t(footer?.title) : '',
          class: _normalizeClass([_ctx.$helper?.getSidebars?.value?.width !== 'fix-sidebar' ? 'min-link-item':'', "link-item"])
        }, [
          _createElementVNode("img", {
            src: footer?.icon || require('@/assets/icons/sidebars/login-page.svg'),
            alt: _ctx.$t(footer?.title),
            style: {"margin-top":"-1px"}
          }, null, 8, _hoisted_16),
          (_ctx.$helper?.getSidebars?.value?.width === 'fix-sidebar')
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t(footer?.title)), 1))
            : _createCommentVNode("", true)
        ], 10, _hoisted_15))
      }), 128))
    ], 4),
    _createVNode(_component_c_modal, {
      onOnClose: _ctx.cancelLogout,
      onOnConfirm: _ctx.onLogout,
      labelText: "componentSignOut",
      active: _ctx.isLogout
    }, null, 8, ["onOnClose", "onOnConfirm", "active"])
  ], 2))
}